import "./ConversationFooter.scss";

import React from "react";

import { renderCreatedAtDateTime } from "../utils/datetime";

const ConversationFooter = ({
  datetime,
  operator,
  isTranslationLoading,
  isTranslated,
  toggleTranslation
}) => {
  const displayOperator = () => {
    const sentBy =
      operator.split(",").length === 1 ? (
        operator
      ) : (
        <span title={operator}>ambiguous</span>
      );

    return <span> by {sentBy}</span>;
  };

  return (
    <div className="ConversationFooter">
      <small>
        Sent {renderCreatedAtDateTime(datetime)}
        {operator && displayOperator()}
      </small>

      <button
        className="ConversationFooter__TranslateButton"
        onClick={toggleTranslation}
        disabled={isTranslationLoading}
      >
        <small>
          {isTranslationLoading
            ? "Translation loading..."
            : isTranslated
              ? "Show original"
              : "Translate message"}
        </small>
      </button>
    </div>
  );
};

export default ConversationFooter;
